<template>
  <div id="desempenho-por-microarea" class="row">
    <div class="col-lg-4 col-md-12">
      <div class="form-group">
        <label for="">Data inicial</label>
        <input
          type="date"
          class="form-control"
          v-model="periodoInicial"
          :disabled="loading"
        />
        <div v-if="loading" class="input-overlay">
          <b-spinner small />
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12">
      <div class="form-group">
        <label for="">Data final</label>
        <input
          type="date"
          class="form-control"
          v-model="periodoFinal"
          :disabled="loading"
        />
        <div v-if="loading" class="input-overlay">
          <b-spinner small />
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12">
      <b-button
        type="submit"
        :disabled="loadingBtn"
        class="btn-submit-filter"
        @click="searchInformation()"
      >
        <b-spinner small class="mr-2" v-if="loadingBtn" />
        <i class="icofont icofont-search-2 mr-2" v-else></i>
        Buscar
      </b-button>
    </div>
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <FonteSincronizadorC />
        </div>
        <div class="info-table-item select-situacao">
          <vue-select
            :options="situacaoOptions"
            label="label"
            placeholder=""
            @input="onChangeSituacao"
            v-model="situacao"
            :disabled="loading"
            :clearable="false"
          >
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div class="info-table-item">
          <acoes
            :callback-pdf="generatePdf"
            :callback-historico="verHistorico"
            :data="displayedCadastros"
            :fields="dataFields"
            name="desempenho-por-microarea"
            :situacaoOptions="situacaoOptions"
            :situacao="situacao"
            :dataInicial="periodoInicial"
            :dataFinal="periodoFinal"
          >
          </acoes>
        </div>
      </div>
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        :dataInicial="periodoInicial"
        :dataFinal="periodoFinal"
        @filterSearch="filterSearch($event)"
        @profissional-selecionado="onProfissionalSelecionado"
        :situacao="situacao"
      ></tabela-cadastros>
    </div>

    <modal-historico-micro-area
      :show.sync="historicoModal.show"
      :loading="historicoModal.loading"
      :items="historicoModal.items"
      @selecionar="carregarHistoricoSelecionado"
    />
  </div>
</template>

<script>
import 'jspdf-autotable'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import utils from '@/mixins/utils.js'
import TabelaCadastros from './TabelaCadastros.vue'
import * as Functions from './functions.js'
import Acoes from './components/Acoes.vue'
import ModalHistoricoMicroArea from './components/ModalHistoricoMicroArea.vue'

export default {
  name: 'DesempenhoPorMicroArea',
  components: {
    PulseLoader,
    TabelaCadastros,
    Acoes,
    ModalHistoricoMicroArea,
  },
  mixins: [utils],
  data() {
    return {
      nu_ine: '',
      cadastros: [],
      cadastrosOriginais: [],
      loading: false,
      periodoInicial: '',
      periodoFinal: '',
      situacaoOptions: [
        {
          label: 'Geral',
          value: 'geral',
        },
        {
          label: 'Gestantes',
          value: 'gestantes',
        },
        {
          label: 'Hipertensão',
          value: 'hipertensao',
        },
        {
          label: 'Diabetes',
          value: 'diabetes',
        },
        {
          label: 'Crianças até 5 anos',
          value: 'criancas',
        },
        {
          label: 'Idosos',
          value: 'idosos',
        },
      ],
      situacao: {
        label: 'Geral',
        value: 'geral',
      },
      dataFinalApi: '',
      dataInicialApi: '',
      filterSearchTable: false,
      searchTable: '',
      dataFields: {
        ...Functions.dataFields,
      },
      loadingBtn: false,
      historicoModal: {
        show: false,
        loading: false,
        tipo: null,
        items: [],
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable !== false) {
        return this.filterSearchTable
      }

      return this.cadastros
    },
  },
  methods: {
    filterSearch(item) {
      this.searchTable = item.search || ''

      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }

      this.filterSearchTable = false
    },

    checkDates() {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (this.periodoInicial === '' && this.periodoFinal === '') {
        this.$toast.error('Selecione uma data de início e de fim!', 'Error:', {
          position: 'topRight',
        })
        return false
      } else {
        if (new Date(this.periodoFinal) > new Date(this.dataFinalApi)) {
          this.$toast.error(
            'A data final não pode ser superior a ' +
              this.formatDate(this.dataFinalApi),
            'Error:',
            {
              position: 'topRight',
            }
          )
          return false
        }

        if (new Date(this.periodoInicial) < new Date(this.dataInicialApi)) {
          this.$toast.error(
            'O período inicial não pode ser inferior a ' +
              this.formatDate(this.dataInicialApi),
            'Error:',
            {
              position: 'topRight',
            }
          )
          return false
        }

        if (new Date(this.periodoInicial) > new Date(this.periodoFinal)) {
          this.$toast.error(
            'O período inicial não pode ser maior do que o período final!',
            'Error:',
            {
              position: 'topRight',
            }
          )
          return false
        }

        return true
      }
    },

    async onChangeSituacao(item) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.situacao = item
    },

    async searchInformation() {
      if (this.$refs.table) {
        this.$refs.table.search = ''
        this.$refs.table.selectedProfissionais = {}
      }
      this.equipe = null

      const datas = this.checkDates()
      if (!datas || this.situacao.value === '') {
        this.cadastros = []
        this.cadastrosOriginais = []
        this.situacao = ''
        return
      }

      try {
        this.loadingBtn = true
        this.loading = true

        this.cadastrosOriginais = []
        this.cadastros = []

        // converte para formato aaaammdd
        const inicio = this.periodoInicial.replaceAll('-', '')
        const fim = this.periodoFinal.replaceAll('-', '')

        const response = await this.$api.get(
          `/app/desempenho-por-acs/${this.$store.state.cod_ibge}/${inicio}/${fim}`
        )

        if (response) {
          let dados = response.data

          if (
            this.$store.state.id_funcao == '3' ||
            this.$store.state.id_funcao == '4'
          ) {
            dados = response.data.filter((item) => {
              return item.nu_ine == this.$store.state.nu_ine
            })
          }

          const dadosPreparados = this.prepararCadastrosComOrdem(dados)

          this.cadastros = dadosPreparados
          this.cadastrosOriginais = [...dadosPreparados]
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingBtn = false
        this.loading = false
      }
    },

    onProfissionalSelecionado({ nu_ine, nu_micro_area, profissional }) {
      const apply = (arr) => {
        if (!Array.isArray(arr)) return
        const idx = arr.findIndex(
          (x) => x.nu_ine === nu_ine && x.nu_micro_area === nu_micro_area
        )
        if (idx !== -1) {
          this.$set(arr[idx], 'profissionalSelected', profissional)
        }
      }

      apply(this.cadastros)
      apply(this.cadastrosOriginais)
      apply(this.filterSearchTable)
    },

    async buscarUltimoPeriodo() {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      try {
        this.loading = true
        const response = await this.$api.get(
          `/app/v2/desempenho-por-acs/${this.$store.state.cod_ibge}/periodo/max`
        )
        if (response) {
          this.periodoFinal = response.data[0].periodo_final
          this.dataFinalApi = response.data[0].periodo_final
          this.periodoInicial = response.data[0].data_inicial
          this.dataInicialApi = response.data[0].periodo_inicial
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async verHistorico(tipo) {
      const situacaoSelecionada = this.situacaoOptions.find(
        (item) => item.value === tipo
      )

      if (!situacaoSelecionada) {
        this.$toast.error('Tipo de histórico inválido.', 'Erro:', {
          position: 'topRight',
        })
        return
      }

      try {
        this.historicoModal.loading = true
        this.historicoModal.items = []
        this.historicoModal.tipo = tipo

        const response = await this.$api.get(
          `/app/microareas/${this.$store.state.cod_ibge}/historicos/tipo/${tipo}`
        )

        if (response.data?.error) {
          this.$toast.error(
            response.data.message || 'Erro ao buscar históricos.',
            'Erro:',
            {
              position: 'topRight',
            }
          )
          return
        }

        this.historicoModal.items = Array.isArray(response.data?.items)
          ? response.data.items
          : []

        if (!this.historicoModal.items.length) {
          this.$toast.info(
            'Nenhum histórico encontrado para esse tipo.',
            'Aviso:',
            {
              position: 'topRight',
            }
          )
          return
        }

        this.historicoModal.show = true
      } catch (error) {
        console.error(error)
        this.$toast.error('Erro ao buscar históricos.', 'Erro:', {
          position: 'topRight',
        })
      } finally {
        this.historicoModal.loading = false
      }
    },

    async carregarHistoricoSelecionado(historico) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
        this.$refs.table.selectedProfissionais = {}
      }

      const tipo = this.historicoModal.tipo

      const situacaoSelecionada = this.situacaoOptions.find(
        (item) => item.value === tipo
      )

      if (!situacaoSelecionada) {
        this.$toast.error('Tipo de histórico inválido.', 'Erro:', {
          position: 'topRight',
        })
        return
      }

      try {
        this.loading = true
        this.filterSearchTable = false
        this.situacao = situacaoSelecionada
        this.cadastros = []
        this.cadastrosOriginais = []
        this.historicoModal.show = false

        const response = await this.$api.get(
          `/app/microareas/${this.$store.state.cod_ibge}/historicos/${historico.uuid_rel}`
        )

        if (response.data?.error) {
          this.$toast.error(
            response.data.message || 'Erro ao carregar histórico.',
            'Erro:',
            {
              position: 'topRight',
            }
          )
          return
        }

        const items = Array.isArray(response.data?.items)
          ? response.data.items
          : []

        const itemsMapeados = items.map((item) => {
          let dados = {}

          try {
            dados =
              typeof item.dados === 'string'
                ? JSON.parse(item.dados)
                : item.dados || {}
          } catch (e) {
            dados = {}
          }

          return {
            no_unidade_saude: item.no_unidade_saude,
            nu_ine: item.nu_ine,
            nu_micro_area: item.nu_micro_area,
            co_equipe: dados.co_equipe || null,
            noms_prof: JSON.stringify(
              item.no_prof_acs_tacs ? [item.no_prof_acs_tacs] : []
            ),
            pessoas_visitadas: Number(dados.visitadas ?? 0),
            pessoas_cadastradas: Number(dados.cadastradas ?? 0),
            cadastros_antigos: Number(dados.cadastros_antigos ?? 0),
            resultado_total: dados.resultado ?? null,
            mudanca_territorio: dados.mudanca_territorio ?? null,

            gestantes_visitadas:
              tipo === 'gestantes' ? dados.visitadas ?? 0 : 0,
            gestantes_cadastradas:
              tipo === 'gestantes' ? dados.cadastradas ?? 0 : 0,
            resultado_gestantes:
              tipo === 'gestantes' ? dados.resultado ?? null : null,

            hipert_visitados: tipo === 'hipertensao' ? dados.visitadas ?? 0 : 0,
            hipert_cadastrados:
              tipo === 'hipertensao' ? dados.cadastradas ?? 0 : 0,
            resultado_hipert:
              tipo === 'hipertensao' ? dados.resultado ?? null : null,

            diab_visitados: tipo === 'diabetes' ? dados.visitadas ?? 0 : 0,
            diab_cadastrados: tipo === 'diabetes' ? dados.cadastradas ?? 0 : 0,
            resultado_diab:
              tipo === 'diabetes' ? dados.resultado ?? null : null,

            criancas_visitadas:
              tipo === 'criancas-5-anos' ? dados.visitadas ?? 0 : 0,
            criancas_cadastradas:
              tipo === 'criancas-5-anos' ? dados.cadastradas ?? 0 : 0,
            resultado_criancas:
              tipo === 'criancas-5-anos' ? dados.resultado ?? null : null,

            pes_idosa_visitadas: tipo === 'idosos' ? dados.visitadas ?? 0 : 0,
            pes_idosa_cadastradas:
              tipo === 'idosos' ? dados.cadastradas ?? 0 : 0,
            resultado_pes_idosa:
              tipo === 'idosos' ? dados.resultado ?? null : null,
          }
        })

        const dadosPreparados = this.prepararCadastrosComOrdem(itemsMapeados)

        this.cadastros = dadosPreparados
        this.cadastrosOriginais = [...dadosPreparados]
      } catch (error) {
        console.error(error)
        this.$toast.error('Erro ao carregar histórico.', 'Erro:', {
          position: 'topRight',
        })
      } finally {
        this.loading = false
      }
    },

    ordenar(data) {
      const sortArray = data.sort(function (a, b) {
        if (Number(a.resultado) < Number(b.resultado)) return 1
        if (Number(a.resultado) > Number(b.resultado)) return -1
        return 0
      })
      return sortArray
    },

    prepararCadastrosComOrdem(data) {
      const lista = data.map((el) => {
        const situacoes = {
          geral: {
            resultado: el.resultado_total,
            visitadas: el.pessoas_visitadas,
            cadastradas: el.pessoas_cadastradas,
          },
          gestantes: {
            resultado: el.resultado_gestantes,
            visitadas: el.gestantes_visitadas,
            cadastradas: el.gestantes_cadastradas,
          },
          hipertensao: {
            resultado: el.resultado_hipert,
            visitadas: el.hipert_visitados,
            cadastradas: el.hipert_cadastrados,
          },
          diabetes: {
            resultado: el.resultado_diab,
            visitadas: el.diab_visitados,
            cadastradas: el.diab_cadastrados,
          },
          criancas: {
            resultado: el.resultado_criancas,
            visitadas: el.criancas_visitadas,
            cadastradas: el.criancas_cadastradas,
          },
          idosos: {
            resultado: el.resultado_pes_idosa,
            visitadas: el.pes_idosa_visitadas,
            cadastradas: el.pes_idosa_cadastradas,
          },
        }

        const { resultado, visitadas, cadastradas } =
          situacoes[this.situacao.value] || situacoes.geral

        return {
          ...el,
          profissionais: el.noms_prof != null ? JSON.parse(el.noms_prof) : [],
          resultado,
          visitadas,
          cadastradas,
        }
      })

      const ordenada = this.ordenar(lista)

      return ordenada.map((item, index) => ({
        ...item,
        ordem: index + 1,
      }))
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.periodoInicial,
        this.periodoFinal,
        this.situacao
      )
    },

    async init() {
      await this.buscarUltimoPeriodo()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style scoped>
#desempenho-por-microarea .select-situacao {
  margin: 10px;
  min-width: 210px;
}

#desempenho-por-microarea .btn-submit-filter {
  margin-top: 30px;
}

#desempenho-por-microarea .input-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 15px 25px 0px 0px;
  pointer-events: none;
}

#desempenho-por-microarea .input-overlay .spinner-border {
  width: 1rem;
  height: 1rem;
}
@media screen and (max-width: 992px) {
  #desempenho-por-microarea .info-table {
    flex-direction: column;
  }
}
</style>
